import { render, staticRenderFns } from "./GupshupChannels.vue?vue&type=template&id=25f0f3f9&scoped=true"
import script from "./GupshupChannels.vue?vue&type=script&lang=js"
export * from "./GupshupChannels.vue?vue&type=script&lang=js"
import style0 from "./GupshupChannels.vue?vue&type=style&index=0&id=25f0f3f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0f3f9",
  null
  
)

export default component.exports